/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {map, Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {
  DeviceModelFormInterface,
  DeviceModelListInterface,
  DeviceModelVariablesListInterface,
} from '@shared/interface';
import {HttpResponse, HttpStatusCode} from '@angular/common/http';
import {
  CoreValidateFormulaInterface,
  ValidateVirtualCustomiseFormulaDto,
  ValidateVirtualModelFormulaDto,
} from '@shared/interface/common/valid-formula.interface';
import { MkadCoreService } from '../mkad-core.service';

@Injectable()
export class MkadDeviceModelService extends MkadBaseService {
  readonly deviceModel = URLS_SERVICE.system.deviceModel;
  readonly device = URLS_SERVICE.system.devices;
  readonly validator = URLS_SERVICE.core.validateFormula;
  private readonly customerBase = URLS_SERVICE.meerkad.customer.base;
  private readonly coreService = inject(MkadCoreService);

  list(): Observable<DeviceModelListInterface[] | null> {
    return this.http.post<DeviceModelListInterface[] | null>(this.baseCore + this.deviceModel.base + this.deviceModel.list);
  }

  create(payload: DeviceModelFormInterface): Observable<DeviceModelFormInterface> {
    return this.http.post<DeviceModelFormInterface>(this.baseCore + this.deviceModel.base + this.deviceModel.create, payload);
  }

  update(payload: DeviceModelFormInterface): Observable<DeviceModelFormInterface> {
    return this.http.post<DeviceModelFormInterface>(this.baseCore + this.deviceModel.base + this.deviceModel.update, payload);
  }

  get(param: number): Observable<DeviceModelFormInterface> {
    return this.http.post<DeviceModelFormInterface>(this.baseCore + this.deviceModel.base + this.deviceModel.get, {id: param});
  }

  getModelVariables(id: number): Observable<DeviceModelVariablesListInterface[]> {
    return this.http.post<DeviceModelVariablesListInterface[]>(this.baseCore +this.deviceModel.base + this.deviceModel.getVariablesByModel, {id});
  }

  getCustomizedVariables(id: number): Observable<DeviceModelVariablesListInterface[]> {
    return this.http.post<DeviceModelVariablesListInterface[]>(this.customerBase + this.device.base + this.deviceModel.getVariablesByModel, {id});
  }

  delete(param: number): Observable<boolean> {
    return this.http.post<HttpResponse<boolean>>(this.baseCore + this.deviceModel.base + this.deviceModel.delete, {id: param}).pipe(
      map((prevResponse) => {
          if (!prevResponse) return true;
          return prevResponse.status === HttpStatusCode.Ok;
        },
      ));
  }

  validate(param: ValidateVirtualModelFormulaDto | CoreValidateFormulaInterface): Observable<boolean> {
    return this.coreService.validateModelFormula(param);
  }

  validateCustomise(param: ValidateVirtualCustomiseFormulaDto | CoreValidateFormulaInterface): Observable<boolean> {
    return this.coreService.validateCustomiseFormula(param);
  }
}
